import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { FavoritesComponent } from "./favorites.component";

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        HeaderModule,
        SidebarModule
    ],
    declarations: [
        FavoritesComponent
    ]
  })
  export class FavoritesModule { }